// extracted by mini-css-extract-plugin
export default {"paged":"_2qk-S"};